// eslint-disable-next-line import/prefer-default-export
export const UPDATE_MANAGER_APP_DATA = 'UPDATE_MANAGER_APP_DATA';
